import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';
import { lookupsJson } from '@ourbranch/lookups';

import { brandConfig } from 'brand-config';
import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';

import useStyles from './sub-risk.styles';

const earthquakeDwellingOptions = lookupsJson.farm.earthquakeDeductible;

const EarthquakeCoverageForm = ({ fieldName, disabled, riskType, state }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const isEarthquakeCoverageHidden =
    brandConfig.farm[state]?.[riskType]?.hiddenCoverages?.includes('earthquakeCoverage');

  if (!isEarthquakeCoverageHidden) {
    return null;
  }

  const deductibleEarthquake2 = getIn(values, `${fieldName}.deductibleEarthquake2`);
  const deductibleEarthquake = getIn(values, `${fieldName}.deductibleEarthquake`);

  const shouldEnableVeneerCheckbox = deductibleEarthquake2 || deductibleEarthquake;

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Earthquake coverage</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={6}
          type="select"
          id={`${fieldName}.deductibleEarthquake2`}
          name={`${fieldName}.deductibleEarthquake2`}
          mode="dark"
          label="Earthquake dwelling & contents"
          options={earthquakeDwellingOptions}
          disabled={disabled}
        />
        <Field
          xs={6}
          type="select"
          id={`${fieldName}.deductibleEarthquake`}
          name={`${fieldName}.deductibleEarthquake`}
          mode="dark"
          label="Earthquake related private structures"
          options={earthquakeDwellingOptions}
          disabled={disabled}
        />
        <Field
          xs={12}
          type="checkbox"
          id={`${fieldName}.hasEarthquakeExteriorVeneerCoverage`}
          name={`${fieldName}.hasEarthquakeExteriorVeneerCoverage`}
          mode="dark"
          label="Earthquake exterior masonry veneer exclusion"
          disabled={disabled || !shouldEnableVeneerCheckbox}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

EarthquakeCoverageForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

EarthquakeCoverageForm.defaultProps = {
  disabled: false
};

export default observer(EarthquakeCoverageForm);
